export enum CertificatePurpose {
  Unknown = 0,
  TLSServerIdentity = 1,
  ServerTrust = 2,
  ClientAuthentication = 3
}

export const infrastructureCertificatePurposeTranslationKey = (enumValue: CertificatePurpose | undefined): string => {
  switch (enumValue) {
    case CertificatePurpose.TLSServerIdentity:
      return 'Infrastructure_CertificatePurpose_TLSServerIdentity'
    case CertificatePurpose.ServerTrust:
      return 'Infrastructure_CertificatePurpose_ServerTrust'
    case CertificatePurpose.ClientAuthentication:
      return 'Infrastructure_CertificatePurpose_ClientAuthentication'
    default:
      return 'Infrastructure_CertificatePurpose_Unknown'
  }
}